<template>
  <sider-subpage-elements
    :items="dashboardsArray"
    :active-value="dashboardId"
    :is-loading="isLoading"
    @change="openDashboard"
  />
</template>

<script>
import SiderSubpageElements from '@/components/SiderSubpageElements';

import { get, call } from 'vuex-pathify';

export default {
  name: 'SiderDashboardsSection',
  components: {
    SiderSubpageElements,
  },
  data: () => ({
    isLoading: false,
    dashboardIdProxy: null,
  }),
  watch: {
    dashboardId: {
      handler(nV) {
        this.dashboardIdProxy = nV;
      },
      immediate: true,
    },
  },
  computed: {
    dashboards: get('dashboards/dashboards'),
    dashboardId() {
      return this.$route.meta.default === 'dashboards' && this.$route.query.id ? +this.$route.query.id : null;
    },
    dashboardsArray() {
      const lastUsedDashboardsIds = JSON.parse(localStorage.getItem('last-used-dashboards') || '[]') || [];
      const order = ['predefined', 'owner', 'shared'];

      return Object.entries(this.dashboards ?? {})
        .flatMap(([role, items]) =>
          items.map(item => ({
            id: item.id,
            name: item.name,
            role,
          }))
        )
        .sort((a, b) => {
          const aIndex = lastUsedDashboardsIds.indexOf(a.id);
          const bIndex = lastUsedDashboardsIds.indexOf(b.id);
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          else if (aIndex !== -1) return -1;
          else if (bIndex !== -1) return 1;
          else if (order.indexOf(a.role) - order.indexOf(b.role) === 0) return a['name'].localeCompare(b['name']);
          return order.indexOf(a.role) - order.indexOf(b.role);
        });
    },
  },
  methods: {
    getDashboards: call('dashboards/getDashboards'),
    openDashboard(dashboardId) {
      this.$nextTick(() => (this.dashboardIdProxy = this.dashboardId));
      if (!dashboardId) return;
      const dashboardData = Object.values(this.dashboards)
        .flat()
        .find(dashboard => dashboard.id === dashboardId);
      this.$router.push({
        name: 'dashboard',
        params: { id: dashboardData.id },
      });
    },
    async parseDashboards() {
      if (Object.values(this.dashboards).length) return (this.isLoading = false);
      this.isLoading = true;
      try {
        await this.getDashboards();
      } catch (error) {
        console.error();
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.parseDashboards();
  },
};
</script>

<style lang="scss" scoped>
.sider-dashboards-section {
  height: 100%;
  transition: opacity 0.2s ease allow-discrete;
}
.sider-dashboards-section__hidden {
  opacity: 0 !important;
  pointer-events: none !important;
}
</style>
